export const langVi = {
  thaydoithongtin: 'Ký xác nhận',
  builongchonnoicap: 'Vui lòng chọn nơi cấp',
  ngayhethan: 'Ngày hết hạn',
  hinhanhcccd: 'Hình ảnh CC(CD)',
  capnhatcmndcccdthanhcong: `Thông tin thay đổi của Quý khách sẽ được DFVN phê duyệt trong thời gian quy định.\nTrong thời gian này, Quý khách vui lòng không thực hiện thay đổi thông tin khác.\nChúng tôi xin chân thành cảm ơn sự hợp tác của Quý khách`,
  gioihan12so: 'Số CCCD không hợp lệ',
  thongtinkhongduocdetrong: 'Thông tin không được để trống',
  vuilongtaianh: `Vui lòng tải ảnh giấy tờ CCCD của bạn.`,
  giaytobatbuocnhap: `Số hiệu giấy tờ bắt buộc nhập.`,
  ngaycapbatbuocnhap: `Ngày cấp không hợp lệ.`,
  ekyccontent: `Vui lòng thực hiện các bước xác thực thông tin dưới đây:`,
  xacthucthongtin: `Cập nhật thông tin`,
  thongtincanhan: `Thông tin cá nhân`,
  signcontent: `Quý khách có thể ký trực tiếp trên màn hình hoặc tải hình ảnh có sẳn chữ ký`,
  trangthaihoso: 'Trạng thái hồ sơ',
  PENDING: 'Đang chờ cập nhật',
  REJECT: 'Từ chối',
  PENDING_note: `Thông tin thay đổi của Quý khách sẽ được DFVN phê duyệt trong thời gian quy định.\n\nTrong thời gian này, Quý khách vui lòng không thực hiện thay đổi thông tin khác.\n\nChúng tôi xin chân thành cảm ơn sự hợp tác của Quý khách`,
  REJECT_note: `Cung cấp lý do từ chối thông tin khách hàng cung cấp.`,
  lydotuchoi: 'Lý do từ chối',
};

export const langEn = {
  thaydoithongtin: 'Sign',
  builongchonnoicap: 'Please select place of issue',
  ngayhethan: 'Expire date',
  hinhanhcccd: 'Photo CID/ID',
  capnhatcmndcccdthanhcong: `Your updated information will be approved by DFVN within the specified time frame.

During this period, please do not make any other changes to your information.
We sincerely appreciate your cooperation.`,
  gioihan12so: 'Your Identity Card No is invalid',
  thongtinkhongduocdetrong: 'This field is required',
  vuilongtaianh: `Please upload a photo of your ID card.`,
  giaytobatbuocnhap: `Document no is mandatory.`,
  ngaycapbatbuocnhap: `Issued date is invalid.`,
  ekyccontent: `Please follow the steps below to verify your information:`,
  xacthucthongtin: `Update information`,
  thongtincanhan: `Profile`,
  signcontent: `You can sign directly on the screen or upload an existing signature image.`,
  trangthaihoso: 'Application status',
  PENDING: 'Pending update',
  REJECT: 'Reject',
  PENDING_note: `Your updated information will be approved by DFVN within the specified time frame.

During this period, please do not make any other changes to your information.
We sincerely appreciate your cooperation.`,
  REJECT_note: `Cung cấp lý do từ chối thông tin khách hàng cung cấp.`,
  lydotuchoi: 'Reject reason',
};
